import {
  Component,
  ViewChild,
  ElementRef,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  OnChanges,
} from '@angular/core';
import { PCTableActionInputModel } from '../../models/pc-table-action-input-model';
import { UserApiService } from '../../services/user-api.service';
import { LoggerService } from 'src/app/services/logger.service';
import { CustomizeResponseService } from '../../services/customize-response.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import * as _ from 'lodash-es';
import { PCSearchRequestModel } from '../../models/pc-search-request-model';
import {
  PCTableInputModel,
  PCTableOutputModel,
} from '../../models/pc-table-input-model';
import { TabelPaging } from '../../interfaces/table';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { CheckBook } from '../../models/check-book';
import { FactorPayment } from '../../models/factor-paymnet';
import { NumericService } from 'src/app/services/numeric.service';
import { PaymentType } from 'src/app/enum/payment-type';

@Component({
  selector: 'app-credit-pay',
  templateUrl: './credit-pay.component.html',
  styleUrls: ['./credit-pay.component.css'],
})
export class CreditPayComponent implements OnChanges {
  public modalSuccessConfirm: boolean = false;
  public loading: boolean = false;
  public checkBooks: any[] = [];

  public checkValue = {
    checkId: '',
    checkDate: '',
    checkDateMessage: '',
    cost: 0,
    costMassage: '',
    checkNumber: '',
    nationalCode: '',
    receiver: '',
    factorDate: '',
    maxValue: 0,
    factorId: '',
  };

  public monthName!: string;

  public constructor(
    private apiService: UserApiService,
    private logger: LoggerService,
    public numericService: NumericService,
    private modalService: NgbModal
  ) {
    this.getCheckBooks();
  }

  @ViewChild('datePicker') popoverDataPicker!: NgbPopover;
  @ViewChild('CreditAddModal') CreditAddModal!: NgbPopover;
  @ViewChild('listPayment') listPaymentElement!: ElementRef;

  @Input() thisItem: any;
  @Output() parentActionOutput = new EventEmitter<PCTableOutputModel>();

  public ngOnChanges(changes: SimpleChanges): void {
    if (
      changes &&
      changes['thisItem'] &&
      changes['thisItem'].currentValue !== undefined
    ) {
      const newData = changes['thisItem'].currentValue;

      if (newData) {
        this.checkValue.factorDate = newData.factorDate;
        this.checkValue.maxValue = _.cloneDeep(newData.totalPrice);
        this.checkValue.cost = _.cloneDeep(newData.totalPrice);
        this.checkValue.factorId = newData.id;
      }
    }
  }

  public callParent(method: string) {
    this.parentActionOutput.emit(new PCTableOutputModel(method, undefined));
  }

  public parentAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Successed':
        this.modalSuccessConfirm = false;
        break;
    }
  }

  public getCheckBooks() {
    try {
      this.loading = true;

      let url = `CheckBook?pageNumber=1&pageSize=10&paging=true&orderBy=&direction=asc`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (!result.data) {
            this.checkBooks = [];
          } else {
            this.checkBooks = result.data.items.map((current) => ({
              id: current.id,
              recivedDate: current.recivedDate,
              bankAccountId: current.bankAccountId,
              bankAccountName: current.bankAccountName,
              name: current.name,
              persianName: current.name,
              checks: [],
              loading: false,
            }));

            setTimeout(() => {
              let selectStockPage = document.getElementById('selectStockPage');
              if (selectStockPage) {
                selectStockPage.classList.remove('animate__backInDown');
              }
            }, 2 * 1000);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => { }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public getCheck(checkBook: any) {
    try {
      checkBook.isOpen = true;
      checkBook.loading = true;

      let url = `Check/ListView/${checkBook.id}`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getWitoutPage(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);

          if (result.succeeded) {
            if (result.data == null) {
              return;
            }
            checkBook.checks = result.data.map((current) => ({
              id: current.id,
              cost: current.cost,
              checkNumber: current.checkNumber,
              accountNumber: current.accountNumber,
              isPassed: current.isPassed,
              paymentId: current.paymentId,
              isSelect: false,
            }));
          }

          checkBook.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          checkBook.loading = false;
        },
        () => { }
      );
    } catch (e) {
      this.logger.addException(e, true);
      checkBook.loading = false;
    }
  }

  public selectCheck(check: any) {
    for (let index = 0; index < this.checkBooks.length; index++) {
      const element = this.checkBooks[index];
      for (
        let secondIndex = 0;
        secondIndex < element.checks.length;
        secondIndex++
      ) {
        const secondelement = element.checks[secondIndex];
        secondelement.isSelect = false;
      }
    }
    if (!check.isSelect) {
      this.checkValue.checkNumber = check.checkNumber;
      this.checkValue.checkId = check.id;
      check.isSelect = true;
    } else {
      this.checkValue.checkNumber = '';
      check.isSelect = false;
    }
  }

  public CheckValidation() {
    var isValidation = true;
    if (
      this.checkValue.nationalCode == '' ||
      this.checkValue.nationalCode == null ||
      this.checkValue.nationalCode == undefined
    ) {
      this.checkValue.nationalCode = `فیلد کد ملی اجباری است`;
      isValidation = false;
    }

    if (
      this.checkValue.checkDate == '' ||
      this.checkValue.checkDate == null
      ) {
      this.checkValue.checkDateMessage = `فیلد تاریخ چک اجباری است`;
      isValidation = false;
    }
    
    if (!/^\d+$/.test(this.checkValue.checkDate)) {
      this.checkValue.checkDateMessage = `فقط عدد مجاز است`;
      isValidation = false;
    }

    if (
      this.checkValue.cost == null ||
      this.checkValue.cost == 0 
      ) {
      this.checkValue.costMassage == `فیلد مبلغ چک اجباری است` ;
      isValidation = false;
    }

    return isValidation;
    // if (
    //   this.checkValue.receiver == '' ||
    //   this.checkValue.receiver  == null ||
    //   this.checkValue.receiver  == undefined
    //   ) {
    //   this.checkValue.receiver =='  فیلد کد ملی اجباری است';
    //   isValidation = false;
    // }
    // else {
    //   this.checkValue.cost == undefined;
    // }
  }

  public savePaymentInfo() {
    if (!this.CheckValidation()) {
      return;
    }

    try {
      this.loading = true;

      let url = `Payment/PaymentImport`;

      const test = this.checkValue;
      const backendJson = {
        totalPrice: this.checkValue.cost,
        description: '',
        paymentType: PaymentType.Check,
        checks: [
          {
            checkId: this.checkValue.checkId,
            checkDate: this.checkValue.checkDate,
            cost: this.checkValue.cost,
            checkNumber: this.checkValue.checkNumber,
            nationalCode: this.checkValue.nationalCode,
            reciver: this.checkValue.receiver,
          },
        ],
        buyFactors: [
          {
            buyFactorId: this.thisItem.id,
          },
        ],
      };

      console.log(backendJson);

      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          if (result.succeeded) {
            this.modalService.dismissAll();
            this.modalSuccessConfirm = true;
          } else {
            this.logger.addListError(result.errorMessages);
          }
          this.loading = false;
        },

        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public changeMonth(val: string) {
    if (this.popoverDataPicker.isOpen()) {
      this.popoverDataPicker.close();
    }
    this.monthName = val;
  }

  public checkMaxFactor() {
    const trueValue = this.numericService.checkMax(
      this.checkValue.maxValue,
      this.checkValue.cost
    );

    this.checkValue.cost = parseInt(trueValue, 10);
  }
}
